import { THOUSAND_DELIMITER, FRACTIONAL_DELIMITER } from '../constants/number';
const NOT_NUMBER_REX = /[^0-9]/g;
const NUMBER_GROUP_REX = /.{1,3}/g;
export function formatNumber(value) {
  const {
    fractional,
    integer,
    sign
  } = parseNumber(String(value));
  const parsedInteger = reverseString(integer).match(NUMBER_GROUP_REX) || [];
  const prettyInteger = parsedInteger.reverse().map(reverseString).join(THOUSAND_DELIMITER);
  return !fractional ? "".concat(sign).concat(prettyInteger) : "".concat(sign).concat(prettyInteger).concat(FRACTIONAL_DELIMITER).concat(fractional);
}
function reverseString(value) {
  return value.split('').reverse().join('');
}
function parseNumber(s) {
  const sign = s[0] === '-' ? '-' : '';
  const [integer, fractional] = s.split('.');
  return {
    fractional: fractional ? fractional.replace(NOT_NUMBER_REX, '') : '',
    integer: integer.replace(NOT_NUMBER_REX, ''),
    sign
  };
}